import { useState } from "react";
import { Popover } from "antd";
import classNames from "classnames";
import { ReactComponent as TickIcon } from "logic/src/components/icons/tick.svg";
import { ReactComponent as ArrowIcon } from "logic/src/components/icons/arrowVertical.svg";
import { useLocation, useNavigate } from "react-router-dom";
import useMessage from "logic/src/utils/useMessage";
import styles from "./index.module.scss";

interface IProps {
  onSwitchToVideo: () => void;
}

const ModelSelector = ({ onSwitchToVideo }: IProps) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const messageApi = useMessage();

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  return (
    <>
      <Popover
        open={open}
        onOpenChange={handleOpenChange}
        arrow={false}
        content={
          <div className={styles.popover}>
            <div
              className={styles.item}
              onClick={() => {
                navigate("/");
                setOpen(false);
              }}
            >
              <div className={styles.title}>
                SenseNova-V6.5-Pro
                <TickIcon
                  className={classNames(styles.tick, {
                    [styles.hidden]: location.pathname !== "/",
                  })}
                />
              </div>
              <div className={styles.description}>
                多模态智能交互，让沟通超越语言
              </div>
            </div>
            <div
              className={styles.item}
              onClick={() => {
                setOpen(false);
                onSwitchToVideo?.();
              }}
            >
              <div className={styles.title}>
                SenseNova-V6.5-Video-Beta
                <div className={styles.betaText}>试用</div>
                <TickIcon
                  className={classNames(styles.tick, {
                    [styles.hidden]:
                      location.pathname !== "/videoUnderstanding",
                  })}
                />
              </div>
              <div className={styles.description}>
                视频分析与剪辑，让AI理解每一瞬间
              </div>
            </div>
          </div>
        }
        trigger="click"
        placement="bottomLeft"
      >
        <div className={styles.container}>
          <p className={styles.text}>
            {location.pathname === "/"
              ? "SenseNova-V6.5-Pro"
              : "SenseNova-V6.5-Video-Beta"}
          </p>
          <ArrowIcon
            className={classNames(styles.icon, open && styles.iconOpen)}
          />
          {messageApi.contextHolder}
        </div>
      </Popover>
    </>
  );
};

export default ModelSelector;
